// Tracks whether an on-device model has been downloaded at least once, so the
// tool buttons can show a "first run downloads a model" hint only until it's
// cached. The model bytes themselves are cached by the browser (the background
// removal library uses the Cache Storage API; the upscale weights are cached by
// the HTTP layer) — this flag is just a lightweight UX signal, mirroring the
// plain-localStorage style of apiKey.ts.

import { LocalOpKind } from './types';

const storageKey = (kind: LocalOpKind) => `assetLab.magicStudio.localOps.${kind}.installed`;

export function isInstalled(kind: LocalOpKind): boolean {
  try {
    return localStorage.getItem(storageKey(kind)) === '1';
  } catch {
    // localStorage can throw in private mode / when disabled.
    return false;
  }
}

export function markInstalled(kind: LocalOpKind): void {
  try {
    localStorage.setItem(storageKey(kind), '1');
  } catch {
    // ignore — the flag is only a hint, nothing breaks without it.
  }
}
